import axios from 'axios';

// search roles api
export async function searchRolesAPI(Data) {
	let roleslist = [];
	const roleName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/roles/search/?roleName=${roleName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		roleslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return roleslist;
}

// check existing role api
export async function getRolesNameAPI(Data) {
	let roleslist = [];
	const roleName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/roles/getRoleName/?roleName=${roleName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		roleslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return roleslist;
}

//create roles api
export async function createRolesAPI(Data, userID) {
	let rolesData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/roles/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		rolesData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return rolesData;
}

//update roles api
export async function updateRolesAPI(Data, roleID, userID) {
	let roleData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/roles/update/?roleID=${roleID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		roleData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return roleData;
}